import React, {useState} from 'react';
import {Typography, Button, Grid} from '@mui/material';
import Category from "./Category";
import {useTranslation} from 'react-i18next';


// ------------------------------- CATEGORIES ARRAY -------------------------------
/*const categoriesData = [
    "Cognition",
    "Emotional Intelligence",
    "General",
    "Achievements",
    "Seasonal",
    "Posts by Sponsors",
    "Reading",
    "Writing",
    "Mathematics",
    "Products",
    "Services",
    "Expressive Communication",
    "Auditory Comprehension",
    "Educational",
    "Education Related",
    "Healthcare Related",
    "Posts by Collaborators",
    "Fine Motor Skills",
    "Gross Motor Skills",
    "Reflexes",
    "Stationary Motor Skills",
    "Movements",
    "Locomotion",
    "Large Object Manipulation",
    "Visual Motor Integration",
    "Grasping"
]*/

const categoriesData = [
    {value: "Cognition", label: "Cognition"},
    {value: "Emotional Intelligence", label: "Emotional Intelligence"},
    {value: "Achievements", label: "Achievements"},
    {value: "Seasonal", label: "Seasonal"},
    {value: "Events by Sponsors", label: "Events by Sponsors"},
    {value: "Reading", label: "Reading"},
    {value: "Writing", label: "Writing"},
    {value: "Products", label: "Products"},
    {value: "Services", label: "Services"},
    {value: "Expressive Communication", label: "Expressive Communication"},
    {value: "Auditory Comprehension", label: "Auditory Comprehension"},
    {value: "Educational", label: "Educational"},
    {value: "Education Related", label: "Education Related"},
    {value: "Posts by Collaborators", label: "Posts by Collaborators"},
    {value: "Healthcare Related", label: "Healthcare Related"},
    {value: "Fine Motor Skills", label: "Fine Motor Skills"},
    {value: "Gross Motor Skills", label: "Gross Motor Skills"},
    {value: "Reflexes", label: "Reflexes"},
    {value: "Stationary Motor Skills", label: "Stationary Motor Skills"},
    {value: "Movements", label: "Movements"},
    {value: "Large Object Manipulation", label: "Large Object Manipulation"},
    {value: "Locomotion", label: "Locomotion"},
    {value: "Visual Motor Integration", label: "Visual Motor Integration"},
    {value: "Grasping", label: "Grasping"}

]
// ------------------------------- CATEGORIES ARRAY -------------------------------

const styles = {
    heading: {
        fontFamily: 'Montserrat',
        fontStyle: 'normal',
        fontWeight: '600',
        fontSize: '1.1rem',
        color: '#1C1B1F',
        marginBottom: '1rem',
        paddingBottom: '0.75rem',
        borderBottom: '2px solid #E8DEF8',
    },
    loadMoreButton: {
        fontFamily: 'Montserrat',
        fontSize: '0.85rem',
        fontWeight: '500',
        color: '#6750A4',
    },
    categoryButton: {
        fontFamily: 'Montserrat',
        fontSize: '0.8rem',
        fontWeight: '500',
        lineHeight: '1.4',
        padding: '0.4rem 0.8rem',
        backgroundColor: '#E8DEF8',
        border: 'none',
        color: '#6750A4',
        margin: '0.25rem',
        borderRadius: '20px',
        textTransform: 'none',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: '#6750A4',
            color: '#FFFFFF',
        },
    },
}

const Categories = ({tag, setTag, setTagBoolean, tagBoolean, axiosCategories, categoriesLoading, loading}) => {
    const {t} = useTranslation();
    //const [categories, setCategories] = useState(axiosCategories);
    const [visible, setVisible] = useState(4);

    const loadMore = () => {
        setVisible((prevValue) => prevValue + 4)
    }

    return (
        <>
            <Grid container justifyContent={'center'} direction={'column'}>
                <Grid item>
                    <Typography style={styles.heading}>
                        {t('Categories to Explore')}
                    </Typography>
                </Grid>
                {loading || categoriesLoading
                    ?
                    <Grid item>
                        {t('Loading Categories')}
                    </Grid>

                    :
                    <Grid item container spacing={1}>
                        <Grid item>
                            {(Array.isArray(axiosCategories) ? axiosCategories : []).slice(0, visible).map((category, index) => {
                                const isSelected = tag?.id === category.id;
                                return (
                                    <Button
                                        key={index}
                                        onClick={() => setTag(category)}
                                        sx={{
                                            fontFamily: 'Montserrat',
                                            fontSize: '0.8rem',
                                            fontWeight: 500,
                                            padding: '0.4rem 0.8rem',
                                            backgroundColor: isSelected ? '#6750A4' : '#E8DEF8',
                                            border: 'none',
                                            color: isSelected ? '#FFFFFF' : '#6750A4',
                                            margin: '0.25rem',
                                            borderRadius: '20px',
                                            textTransform: 'none',
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                                backgroundColor: '#6750A4',
                                                color: '#FFFFFF',
                                            },
                                        }}
                                    >
                                        {t(`AboutPage.Categories.${category.name}`, { defaultValue: category.name })}
                                    </Button>
                                )
                            })}
                        </Grid>
                        {/* {filters} */}
                        <Grid item container justifyContent={'space-evenly'} className={'categoryLoadMore'}>
                            {visible <= (axiosCategories.length - 1) &&
                                <button className={'categoryLoadMoreButton'} onClick={loadMore}>
                                    <Typography style={styles.loadMoreButton}>
                                        {t('Load More . . .')}
                                    </Typography>
                                </button>
                            }
                            {tag &&
                                <button className={'categoryLoadMoreButton'} onClick={() => setTag(null)}>
                                    <Typography style={styles.loadMoreButton}>
                                        {t('Remove filter')}
                                    </Typography>
                                </button>
                            }
                        </Grid>
                    </Grid>
                }

            </Grid>
        </>
    )
}

export default Categories
